import axios from "axios";

export const LikeNews = async (appNewsId, farmerId) => {
  const token = JSON.parse(localStorage.getItem("authentication"));
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  const body = { appNewsId, farmerId };

  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_API}/api/news/LikeNews`,
      body,
      config
    );
    return { status: 200, payload: data };
  } catch (error) {
    console.error("LikeNews error:", error);
    const status = error?.response?.status || 500;
    return { status, payload: null };
  }
};
